import { render } from "./KpiHeader.vue?vue&type=template&id=1bf8f4a7&scoped=true&ts=true"
import script from "./KpiHeader.vue?vue&type=script&lang=ts"
export * from "./KpiHeader.vue?vue&type=script&lang=ts"

import "./KpiHeader.vue?vue&type=style&index=0&id=1bf8f4a7&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf8f4a7"]])

export default __exports__